import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, Validator} from '@angular/forms';

/**
 * Kontrola, zda jsou uvedeny povinné údaje o vlastníkovi v případě jeho souhlasu.
 * */
@Injectable({
  providedIn: 'root'
})
export class VlastnikValidator implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    let errors = {};
    let souhlas = control.parent?.get('souhlasVlastnika')?.value;

    if (!souhlas) {
      return null;
    }

    let values = control.value;

    // musí být uvedena adresa
    let adresaControl = control.get('adresa');
    if (!values?.adresa) {
      adresaControl?.setErrors({ vlastnikValidator: true });
      errors['adresaError'] = 'U vlastníka musí být vyplněna adresa.';
    }

    // musí být uvedeno (jméno a příjmení) nebo obchodní název
    let jmenoControl = control.get('jmeno');
    let prijmeniControl = control.get('prijmeni');
    let nazevControl = control.get('obchNaz');
    if (!((values?.jmeno && values?.prijmeni) || values?.obchNaz)) {
      if (!values?.jmeno) jmenoControl?.setErrors({ vlastnikValidator: true });
      if (!values?.prijmeni) prijmeniControl?.setErrors({ vlastnikValidator: true });
      if (!values?.obchNaz) nazevControl?.setErrors({ vlastnikValidator: true });
      errors['jmenoError'] = 'U vlastníka musí být vyplněno jméno a příjmení nebo obchodní název.';
    }

    // jméno ani příjmení se považuje za validní, pokud je vyplněn obchodní název
    if (values?.obchNaz) {
      jmenoControl?.setErrors(null);
      prijmeniControl?.setErrors(null);
    }

    // obchodní název je považován za validní, pokud je vyplněno buď jméno, příjmení nebo obojí
    if (values?.jmeno || values?.prijmeni) {
      nazevControl?.setErrors(null);
    }

    return Object.keys(errors).length != 0 ? errors : null;
  }
}
